import { render } from "./PropValue.vue?vue&type=template&id=4133e2a0&scoped=true"
import script from "./PropValue.vue?vue&type=script&lang=js"
export * from "./PropValue.vue?vue&type=script&lang=js"

import "./PropValue.vue?vue&type=style&index=0&id=4133e2a0&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4133e2a0"]])

export default __exports__